import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatComponentsModule } from 'app/modules/mat-components/mat-components.module';
import { AuthGuard } from 'app/shared/services/Guards/Auth-Guard/auth-guard.service';
import { WelcomeComponent } from 'app/modules/user/components/welcome/welcome.component';
import { LoginGuard } from 'shared/services/Guards/Login/login-guard.service';
import { ResetPasswordModelComponent } from './components/welcome/reset-password-model/reset-password-model.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatComponentsModule,
    RouterModule.forChild([
      { path: 'welcome', component: WelcomeComponent, canActivate: [LoginGuard] },
    ])
  ],
  declarations: [
    WelcomeComponent,
    ResetPasswordModelComponent,
  ],
  exports: [
    CommonModule,
    SharedModule,
    MatComponentsModule,
    ReactiveFormsModule
  ],
  providers: [
    AuthGuard,
    LoginGuard
  ],
  entryComponents: [
    ResetPasswordModelComponent
  ],
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/modules/user/user.module.ts